var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('div',{attrs:{"id":"list_menu"}},[_c('router-link',{attrs:{"to":"/cfm/"}},[_vm._v("QSL card CFM")]),_c('router-link',{attrs:{"to":"/cfm/loggers"}},[_vm._v("eLogs CFM")])],1),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }